<template>
    <div class="modal fade" id="addKeywords" tabindex="-1" role="dialog" aria-labelledby="addEditCampaignGroup" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content campaign-g-addedit">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">Add Keywords</h5>
                    <button type="button" @click="resetSavedVales" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <!-- <h2 class="text-center">Editing Campaign Group</h2> -->
                    <div class="form-container">
                        <!-- form start-->
                        <form>
                            <div class="row">
                                <div class="col">
                                    <div class="row">
                                     <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Keywords</label>
                                        <textarea v-model="keywordText" placeholder='Keywords' class="form-control" style="height:200px;">Keyword List</textarea>

                                    </div>
                                    </div>
                                    <div align="center" class="col-md-12">
                                          <span style="color:red">{{validationMessageKeyword}}</span>
                                    </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="row">
                                        <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Type</label>
                                        <select v-model="keywordType" class="form-control">
                                            <option value="">Type</option>
                                            <option>Brand Keywords</option>
                                            <option>ASIN Keywords</option>
                                            <option>Category Keywords</option>
                                            <option>Category Interest</option>
                                            <option>Competitor</option>
                                            <option>Competitor ASINS</option>
                                            <option>Auto Keywords</option>
                                            <option>Miscellaneous</option>
                                        </select>
                                    </div>
                                        </div>

                                        <div align="center" class="col-md-12">
											<span class="no-data-style">{{validationMessageType}}</span>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="col">
                                      <div >
                                   <span style="color:red">{{validationMessage}}</span>
                                </div>
                                </div> -->

                            </div>
                        </form>
                        <!-- form end-->
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="resetSavedVales">Cancel</button>
                    <button type="button" class="btn btn-primary"  @click="saveKeywordObject">Save</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'AddKeywordModal',
    data() {
        return  {
            keywordText:'',
            keywordType:'',
            validationMessageKeyword:"",
            validationMessageType:"",
        }
    },
    props: {
        selectedKeyword: {
            type: Object,
        }
    },
    watch: {
        selectedKeyword() {
            if (this.selectedKeyword && this.selectedKeyword.keyword) {
				//    this.keywordText = this.selectedKeyword.keyword.join(', ')
                      this.keywordText = this.selectedKeyword.keyword.join('\n')
                	   this.keywordType = this.selectedKeyword.type
            }
        },
       keywordText(){
           if(this.keywordText!='')
           this.validationMessageKeyword=''
       },
         keywordType(){
           if(this.keywordType!='')
           this.validationMessageType=''
       }
    },
    methods: {
        saveKeywordObject() {
           if(this.keywordText=='')
           {
              this.validationMessageKeyword="Keyword List is Empty"
           }
           else if(this.keywordType=='')
           {
              this.validationMessageType="Keyword Type is Not Selected"
           }
           else
           {
			let keywordObject = {}
			if(this.keywordText){
				 keywordObject = {
					keyword: this.keywordText.split('\n').map((element) => {
						return element.trim()
					}),
					type: this.keywordType
				}
            if (this.selectedKeyword && this.selectedKeyword.keywordIndex > -1) {
                keywordObject['keywordIndex'] = this.selectedKeyword.keywordIndex

            }
            
				this.resetSavedVales()
				this.$emit('saveKeyword', keywordObject)
            }
           $('#addKeywords').modal('hide');
           	this.resetSavedVales()
           }

        },
        resetSavedVales() {
            this.validationMessageKeyword="",
            this.validationMessageType=""
            this.keywordText = ''
            this.keywordType = ''
            this.$emit('resetSelectedKeyword')
        }
    }

}
</script>

<style lang="scss">

</style>
